import { TargetStatusRequestTargetKind } from '@/api-client/target/model';

export const KAFKA_INSTANCE_TYPE = {
  CLUSTER: 'cluster',
  BROKER: 'broker',
  TOPIC: 'topic',
} as const;

export const DEFINED_KAFKA_INSTANCE_TYPE = {
  CLUSTER_ZOOKEEPER: 'cluster(zookeeper)',
  CLUSTER: 'cluster',
  BROKER: 'broker',
  TOPIC: 'topic',
} as const;

export const KafkaInstanceKind = {
  KAFKA_BROKER: TargetStatusRequestTargetKind.KAFKA_BROKER,
  KAFKA_CLIENT: TargetStatusRequestTargetKind.KAFKA_CLIENT,
  KAFKA_CLUSTER: TargetStatusRequestTargetKind.KAFKA_CLUSTER,
  KAFKA_CLUSTER_CONSUMER: TargetStatusRequestTargetKind.KAFKA_CLUSTER_CONSUMER,
  KAFKA_CLUSTER_CONSUMER_GROUP: TargetStatusRequestTargetKind.KAFKA_CLUSTER_CONSUMER_GROUP,
  KAFKA_ZOOKEEPER: TargetStatusRequestTargetKind.KAFKA_ZOOKEEPER,
  KAFKA_BROKER_TOPIC: TargetStatusRequestTargetKind.KAFKA_BROKER_TOPIC,
  KAFKA_CLUSTER_PARTITION: TargetStatusRequestTargetKind.KAFKA_CLUSTER_PARTITION,
  KAFKA_CLUSTER_TOPIC: TargetStatusRequestTargetKind.KAFKA_CLUSTER_TOPIC,
  KAFKA_CLUSTER_TOPIC_CONSUMER_GROUP:
    TargetStatusRequestTargetKind.KAFKA_CLUSTER_TOPIC_CONSUMER_GROUP,
} satisfies Partial<typeof TargetStatusRequestTargetKind>;

export const KafkaInstanceKindFromMainView = {
  cluster: TargetStatusRequestTargetKind.KAFKA_CLUSTER,
  'cluster(zookeeper)': TargetStatusRequestTargetKind.KAFKA_CLUSTER,
  broker: TargetStatusRequestTargetKind.KAFKA_BROKER,
  kafka_cluster_topic: TargetStatusRequestTargetKind.KAFKA_CLUSTER_TOPIC,
  kafka_broker_topic: TargetStatusRequestTargetKind.KAFKA_BROKER_TOPIC,
} as const;
